export default __webpack_public_path__ + "static/media/cutting-stones.c4d110e6.md";